<template>
<div class="chapter">
<div class="inner_page">
<p class="ded2">With love to my grandson ADAM MIX, whose claim to fame is that he advertised <em>Larkspur</em> on his underwear.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// MotherRoad_dedi-1.vue?760c75d4